import { useEffect, useRef, useState } from "react";

/** Ancho del contenedor con ResizeObserver (fallback 320 px para print / primer render). */
export function useAncho<T extends HTMLElement = HTMLDivElement>(inicial = 320) {
  const ref = useRef<T>(null);
  const [ancho, setAncho] = useState(inicial);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setAncho(el.clientWidth || inicial);
    if (typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(([e]) => { const w = Math.round(e.contentRect.width); if (w > 0) setAncho(w); });
    ro.observe(el);
    return () => ro.disconnect();
  }, [inicial]);
  return { ref, ancho };
}
